export const otherTypeCodes = [
  'child',
  'other',
  'relative',
  'professional',
  'friend',
  'neighbor',
];

export const contactPreferencesNextPath = (required_step) => {
  let copy;
  if (required_step == 'campaign_type') {
    return contactPreferenceCopy.default;
  } else if (required_step == 'community') {
    return contactPreferenceCopy.community;
  }
};

export const contactPreferenceCopy = {
  default: {
    header: `A member of our Client Services Team will contact you.`,
    description: `Facilisi cras non sed dui elementum risus. Arcu nullam dis tempus vel neque nisl interdum arcu scelerisque. Risus eget eu sollicitudin diam sed sollicitudin. Nibh consectetur ante lacinia at.`,
  },
  community: {
    header: `Since you don’t have a community to ask for help a member of our Client Services Team will contact you.`,
    description: `Successful fundraising relies on community support. A member of our Client Services Team is available to help you identify networks within your community to ask for help. What’s the best way to reach you to explore your community connections for fundraising? `,
  },
};

export const identityOptions = [
  {
    label: 'Client',
    value: 1,
  },
  {
    label: 'Spouse',
    value: 2,
  },
  {
    label: 'Parent of minor client',
    value: 3,
  },
  {
    label: 'Legal Guardian',
    value: 4,
  },
  {
    label: 'POA',
    value: 5,
  },
];

export const languageOptions = [
  {
    label: 'English',
    value: 'English',
  },
  {
    label: 'Spanish',
    value: 'Spanish',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

export const nameTitleOptions = [
  {
    label: 'Dr.',
    value: 'Dr.',
  },
  {
    label: 'Mr.',
    value: 'Mr.',
  },
  {
    label: 'Mrs.',
    value: 'Mrs.',
  },
  {
    label: 'Ms.',
    value: 'Ms.',
  },
  {
    label: 'Rev.',
    value: 'Rev.',
  },
  {
    label: 'Master',
    value: 'Master',
  },
];

export const nameSuffixOptions = [
  {
    label: 'Jr.',
    value: 'Jr.',
  },
  {
    label: 'Sr.',
    value: 'Sr.',
  },
  {
    label: 'II',
    value: 'II',
  },
  {
    label: 'III',
    value: 'III',
  },
  {
    label: 'IV',
    value: 'IV',
  },
];

export const genderOptions = [
  {
    label: 'Male',
    value: 'Male',
  },
  {
    label: 'Female',
    value: 'Female',
  },
  {
    label: 'Nonbinary',
    value: 'Nonbinary',
  },
];

export const maritalStatusOptions = [
  {
    label: 'Divorced',
    value: 'Divorced',
  },
  {
    label: 'Engaged',
    value: 'Engaged',
  },
  {
    label: 'Married',
    value: 'Married',
  },
  {
    label: 'Partner',
    value: 'Partner',
  },
  {
    label: 'Separated',
    value: 'Separated',
  },
  {
    label: 'Single',
    value: 'Single',
  },
  {
    label: 'Widowed',
    value: 'Widowed',
  },
];

export const ethnicityOptions = [
  {
    label: 'White',
    value: 'White',
  },
  {
    label: 'Hispanic or Latino',
    value: 'Hispanic or Latino',
  },
  {
    label: 'Black or African American',
    value: 'Black or African American',
  },
  {
    label: 'Native American',
    value: 'Native American',
  },
  {
    label: 'Asian',
    value: 'Asian',
  },
  {
    label: 'Other',
    value: 'Other',
  },
  {
    label: 'Prefer not to answer this question',
    value: 'Prefer not to answer this question',
  },
];

export const stateOptions = [
  {
    label: 'California',
    value: 'CA',
  },
  {
    label: 'Texas',
    value: 'TX',
  },
  {
    label: 'Florida',
    value: 'FL',
  },
  {
    label: 'New York',
    value: 'NY',
  },
  {
    label: 'Illinois',
    value: 'IL',
  },
];

export const phoneOptions = [
  {
    label: 'Cell',
    value: 'Cell',
  },
  {
    label: 'Direct',
    value: 'Direct',
  },
  {
    label: 'Fax',
    value: 'Fax',
  },
  {
    label: 'Home',
    value: 'Home',
  },
  {
    label: 'Main',
    value: 'Main',
  },
  {
    label: 'Office',
    value: 'Office',
  },
  {
    label: 'Pager',
    value: 'Pager',
  },
];
